import { api } from "./api";

export interface User {
  id: number;
  email: string;
  username: string;
  avatar_url?: string;
  is_admin?: boolean;
  credits?: number;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  username: string;
  password: string;
  /** 邀请模式下必填 */
  invite_code?: string;
  wechat_id?: string;
}

export type RegistrationMode = "invite" | "public";

export interface RegisterConfig {
  mode: RegistrationMode;
}

export interface AuthResponse {
  access_token: string;
  token_type: string;
  user: User;
}

export async function login(data: LoginRequest): Promise<AuthResponse> {
  const res = await api.post<AuthResponse>("/auth/login", data);
  localStorage.setItem("token", res.access_token);
  return res;
}

export async function register(data: RegisterRequest): Promise<AuthResponse> {
  const res = await api.post<AuthResponse>("/auth/register", data);
  localStorage.setItem("token", res.access_token);
  return res;
}

export async function getRegisterConfig(): Promise<RegisterConfig> {
  return api.get<RegisterConfig>("/auth/register-config");
}

export async function getCurrentUser(): Promise<User> {
  return api.get<User>("/auth/me");
}

export function logout() {
  localStorage.removeItem("token");
  window.location.href = "/login";
}

export function getToken(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem("token");
}

export function isAuthenticated(): boolean {
  return !!getToken();
}
